// @ts-nocheck
import React, { forwardRef } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { makeStyles } from '@material-ui/styles';
import CheckSVG from './assets/check.svg';
import { colors, buttonColors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

const useStyles = makeStyles((theme: ITheme) => ({
  label: {
    display: 'table',
    width: '100%',
  },
  input: {
    display: 'none',
    '&:checked + $icon': {
      backgroundImage: `url(${CheckSVG})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      borderColor: colors.gainsboro,
    },
  },
  cell: {
    display: 'table-cell',
    verticalAlign: 'top',
  },
  icon: {
    display: 'block',
    width: 24,
    height: 24,
    marginRight: theme.spacing(2),
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: colors.lightGray,
  },
  text: {
    display: 'table-cell',
    verticalAlign: 'top',
  },
  error: {
    borderColor: theme.palette.error.main,
  },
  disabled: {
    backgroundColor: buttonColors.secondaryButtonDisabled,
    borderColor: buttonColors.secondaryButtonDisabled,
  },
}));

const Checkbox = forwardRef((props, ref) => {
  const { id, error, disabled, children, ...rest } = props;
  const classes = useStyles();

  return (
    <label className={classes.root} htmlFor={id}>
      <div className={classes.cell}>
        <input
          id={id}
          className={cn(classes.input, {
            [classes.disabled]: disabled,
          })}
          type="checkbox"
          ref={ref}
          {...rest}
        />
        <i
          className={cn(classes.icon, {
            [classes.error]: error,
            [classes.disabled]: disabled,
          })}
        />
      </div>
      <div className={classes.cell}>{children}</div>
    </label>
  );
});

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  children: PropTypes.node,
};

Checkbox.defaultProps = {
  error: false,
  disabled: false,
  children: null,
};

export default Checkbox;
